import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.25),

      '&$titleBold $title': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    titleBold: {},

    title: {},
    extra: {
      color: COLORS.gray.gray40,
    },
    stonlyIcon: {
      marginLeft: theme.spacing(0.75),
    },
  }),
  { name: 'PanelTitle' }
);
